import {CellAreaDefinition} from '../area-definition';
import {BOTTOM_EDGE_CELL_AREA_DEF} from './bottom-edge';
import {BOTTOM_SIDE_CELL_AREA_DEF} from './bottom-side';
import {LEFT_EDGE_CELL_AREA_DEF} from './left-edge';
import {LEFT_SIDE_CELL_AREA_DEF} from './left-side';
import {RIGHT_EDGE_CELL_AREA_DEF} from './right-edge';
import {RIGHT_SIDE_CELL_AREA_DEF} from './right-side';
import {TOP_EDGE_CELL_AREA_DEF} from './top-edge';
import {TOP_SIDE_CELL_AREA_DEF} from './top-side';

export {EMPTY_CELL_AREA_DEF} from './empty';
export {HEADER_CELL_AREA_DEF} from './header';
export const EDGE_CELL_AREAS_DEF: CellAreaDefinition[] = [
    TOP_EDGE_CELL_AREA_DEF,
    RIGHT_EDGE_CELL_AREA_DEF,
    BOTTOM_EDGE_CELL_AREA_DEF,
    LEFT_EDGE_CELL_AREA_DEF
];
export const SIDE_CELL_AREAS_DEF: CellAreaDefinition[] = [
    TOP_SIDE_CELL_AREA_DEF,
    RIGHT_SIDE_CELL_AREA_DEF,
    BOTTOM_SIDE_CELL_AREA_DEF,
    LEFT_SIDE_CELL_AREA_DEF
];
